<awc-tree
  #tree
  [isMultiSelect]="true"
  [items]="items"
  [selectedItems]="treeSelectedIds"
  (selectedItemsChange)="selectedItemsChanged()"
  (treeItemClicked)="onTreeItemClicked($event)"></awc-tree>
